import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import { CircularProgress } from '@material-ui/core'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import Security from '../../commons/security/Security.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import PeriodoPresupuestarioPresupuestoGrid from './PeriodoPresupuestarioPresupuestoGrid.jsx'

const KPI_CONFIG = [
    { key: 'asignado',              colorClass: 'success', icon: 'la la-dollar',       labelId: 'periodoPresupuestario.kpi.asignado',              labelDefault: 'Presupuesto asignado' },
    { key: 'comprometido',          colorClass: 'warning', icon: 'fa fa-clock-o',      labelId: 'periodoPresupuestario.kpi.comprometido',          labelDefault: 'Comprometido' },
    { key: 'consumido',             colorClass: 'danger',  icon: 'fa fa-check-circle', labelId: 'periodoPresupuestario.kpi.consumido',             labelDefault: 'Consumido' },
    { key: 'comprometidoConsumido', colorClass: 'primary', icon: 'la la-tasks',        labelId: 'periodoPresupuestario.kpi.comprometidoConsumido', labelDefault: 'Comprometido + Consumido' },
    { key: 'restante',              colorClass: 'info',    icon: 'la la-pie-chart',    labelId: 'periodoPresupuestario.kpi.restante',              labelDefault: 'Restante' },
]

class PeriodoPresupuestarioBaseDetalle extends Component {
    constructor(props) {
        super(props)
        this.ajaxHandler = new AjaxHandler()
        this.state = {
            kpis:             { asignado: 0, comprometido: 0, consumido: 0, comprometidoConsumido: 0, restante: 0 },
            loading:          true,
            porcentaje:       ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
            nombre:           '',
            redirectTo:       null,
            subregionId:      null,
            subregionNombre:  '',
            moviles:          [],
            loadingMoviles:   false,
            showModalMoviles: false,
            filtroMoviles:    '',
        }
        this.handleVerMoviles = this.handleVerMoviles.bind(this)
    }

    componentWillMount() {
        if (Security.hasPermission('PERIODO_PRESUPUESTARIO_BASES_VER')) {
            this.ajaxHandler.subscribe(this)
            this.loadData()
        } else {
            this.setState({ redirectTo: '/error' })
        }
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe()
    }

    loadData() {
        var id = this.props.match.params.id
        var metadataPromise = this.ajaxHandler.getJson('/presupuestos/resumen-bases?soloActivo=false')
            .then(function(data) {
                if (!data || !data.bases) return
                var base = data.bases.find(function(b) { return String(b.id) === String(id) })
                if (base) {
                    this.setState({
                        nombre:          base.descripcion,
                        subregionId:     base.subregion_id || null,
                        subregionNombre: base.subregion_nombre || '',
                    })
                }
            }.bind(this))
        var kpisPromise = this.ajaxHandler.getJson('/presupuestos/bases/' + id + '/kpis')
            .then(function(data) {
                if (!data) return
                this.setState({
                    kpis: {
                        asignado:              data.asignado,
                        comprometido:          data.comprometido,
                        consumido:             data.consumido,
                        comprometidoConsumido: data.comprometido + data.consumido,
                        restante:              data.asignado - data.comprometido - data.consumido,
                    },
                })
            }.bind(this))
        Promise.all([metadataPromise, kpisPromise])
            .then(function() { this.setState({ loading: false }) }.bind(this))
    }

    refreshKpis() {
        var id = this.props.match.params.id
        this.ajaxHandler.getJson('/presupuestos/bases/' + id + '/kpis')
            .then(function(data) {
                if (!data) return
                this.setState({
                    kpis: {
                        asignado:              data.asignado,
                        comprometido:          data.comprometido,
                        consumido:             data.consumido,
                        comprometidoConsumido: data.comprometido + data.consumido,
                        restante:              data.asignado - data.comprometido - data.consumido,
                    },
                })
            }.bind(this))
    }

    handleVerMoviles() {
        var id = this.props.match.params.id
        this.setState({ showModalMoviles: true, loadingMoviles: true, filtroMoviles: '' })
        this.ajaxHandler.getJson('/presupuestos/bases/' + id + '/moviles')
            .then(function(data) { this.setState({ moviles: data || [] }) }.bind(this))
            .finally(function() { this.setState({ loadingMoviles: false }) }.bind(this))
    }

    formatCurrency(value) {
        return new Intl.NumberFormat(LocaleFormat.getNumberLocale(), { style: 'currency', currency: 'ARS' }).format(value || 0)
    }

    getIconColor(disponible, asignado) {
        if (asignado === 0 && disponible === 0) return 'gray'
        const pct = (disponible / asignado) * 100
        if (pct === 100) return '#474789'
        if (pct >= this.state.porcentaje) return '#28D094'
        if (pct > 0) return '#F1EA7F'
        return '#FF4961'
    }

    calcPct(value, base) {
        if (!base || base === 0) return 0
        return Math.min(100, Math.round((value / base) * 100))
    }

    kpiSubtitle(key, kpis) {
        var intl = this.props.intl
        if (key === 'asignado')     return intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' })
        if (key === 'comprometido')          return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.comprometido', defaultMessage: 'Tickets aprobados' })
        if (key === 'consumido')             return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.consumido', defaultMessage: 'Tickets cerrados' })
        if (key === 'comprometidoConsumido') return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.comprometidoConsumido', defaultMessage: '{pct}% del total' }, { pct: this.calcPct(kpis.comprometidoConsumido, kpis.asignado) })
        if (key === 'restante')              return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.distribuido', defaultMessage: '{pct}% del total' }, { pct: this.calcPct(kpis.restante, kpis.asignado) })
        return ''
    }

    render() {
        var kpis    = this.state.kpis
        var loading = this.state.loading
        var id      = this.props.match.params.id
        var action  = this.props.action
        var baseUrl = this.props.match.url.replace('/' + id + (action === 'EDIT' ? '/edit' : ''), '')

        if (this.state.redirectTo) return <Redirect push to={this.state.redirectTo} />

        return (
            <React.Fragment>
                {/* Header panel */}
                {this.state.nombre && (
                    <div className="row mt-1 mb-2">
                        <div className="col-12">
                            <div style={{ borderLeft: '4px solid #1E9FF2', backgroundColor: '#fff', padding: '10px 16px', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <h4 className="content-header-title mb-0">
                                    <Link to={baseUrl}><FormattedMessage id="periodoPresupuestario.grid.base" defaultMessage="Base" /></Link>
                                    {' '}<strong>{this.state.nombre}</strong>
                                </h4>
                                <div className="d-flex align-items-center">
                                    {this.state.subregionNombre && this.state.subregionId && (
                                        <span className="mr-3" style={{ fontSize: '0.9rem' }}>
                                            <FormattedMessage id="periodoPresupuestario.grid.subregion" defaultMessage="Subregión" />:{' '}
                                            <Link to={'/periodoPresupuestario/subregiones/' + this.state.subregionId} style={{ fontWeight: 'bold' }}>{this.state.subregionNombre}</Link>
                                        </span>
                                    )}
                                    <button className="btn btn-primary" onClick={this.handleVerMoviles}>
                                        <i className="fa fa-search mr-1"></i>
                                        <FormattedMessage id="periodoPresupuestario.base.ver_vehiculos" defaultMessage="Ver vehículos" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* KPI Cards */}
                <div className="row">
                    {KPI_CONFIG.map(kpi => (
                        <div key={kpi.key} className="col">
                            <div className="card pull-up">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="media d-flex">
                                            <div className="media-body text-left">
                                                <h3 className={'text-' + kpi.colorClass + ' font-weight-500'}>
                                                    {loading ? <CircularProgress size={22} /> : this.formatCurrency(kpis[kpi.key])}
                                                </h3>
                                                <h6>
                                                    <FormattedMessage id={kpi.labelId} defaultMessage={kpi.labelDefault} />
                                                </h6>
                                                <small className="text-muted">{this.kpiSubtitle(kpi.key, kpis)}</small>
                                            </div>
                                            <div>
                                                <i className={kpi.icon + ' text-' + kpi.colorClass + ' font-large-2 float-right'}></i>
                                            </div>
                                        </div>
                                        <div className="progress progress-sm mt-1 mb-0 box-shadow-2">
                                            <div
                                                className={'progress-bar bg-gradient-x-' + kpi.colorClass}
                                                role="progressbar"
                                                style={{ width: this.calcPct(kpis[kpi.key], kpis.asignado) + '%' }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* PresupuestoGrid existente */}
                {Security.hasPermission('PERIODO_PRESUPUESTARIO_BASES_VER') && (
                    <div className="row">
                        <div className="col-12">
                            <PeriodoPresupuestarioPresupuestoGrid
                                modulo="bases"
                                id={id}
                                presupuestable="base"
                                editar={Security.hasPermission('PERIODO_PRESUPUESTARIO_BASES_MODIFICAR') && action === 'EDIT'}
                                setLoading={(val) => this.setState({ loading: val })}
                                onPresupuestoUpdated={() => this.refreshKpis()}
                            />
                        </div>
                    </div>
                )}
                {/* Modal Vehículos */}
                {this.state.showModalMoviles && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header bg-fleet">
                                    <h5 className="modal-title text-white"><FormattedMessage id="periodoPresupuestario.base.vehiculos_asignados" defaultMessage="Vehículos asignados" /></h5>
                                    <button type="button" className="close text-white" onClick={() => this.setState({ showModalMoviles: false })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage({ id: 'periodoPresupuestario.modal.filtrar', defaultMessage: 'Filtrar...' })}
                                            value={this.state.filtroMoviles}
                                            onChange={e => this.setState({ filtroMoviles: e.target.value })}
                                        />
                                    </div>
                                    {this.state.loadingMoviles ? (
                                        <div className="text-center py-3"><CircularProgress /></div>
                                    ) : (() => {
                                        var filtro = this.state.filtroMoviles.toLowerCase()
                                        var list = filtro
                                            ? this.state.moviles.filter(function(m) {
                                                return (m.marca && m.marca.toLowerCase().indexOf(filtro) !== -1)
                                                    || (m.dominio && m.dominio.toLowerCase().indexOf(filtro) !== -1)
                                                    || (m.unidad && m.unidad.toLowerCase().indexOf(filtro) !== -1)
                                                    || (m.modelo && m.modelo.toLowerCase().indexOf(filtro) !== -1)
                                            })
                                            : this.state.moviles
                                        return list.length === 0 ? (
                                            <p className="text-muted text-center"><FormattedMessage id="periodoPresupuestario.base.sin_vehiculos" defaultMessage="Sin vehículos asignados" /></p>
                                        ) : (
                                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table className="table table-sm table-hover">
                                                <thead>
                                                    <tr>
                                                        <th><FormattedMessage id="periodoPresupuestario.modal.marca" defaultMessage="Marca" /></th>
                                                        <th><FormattedMessage id="periodoPresupuestario.modal.dominio" defaultMessage="Dominio" /></th>
                                                        <th><FormattedMessage id="periodoPresupuestario.modal.unidad" defaultMessage="Unidad" /></th>
                                                        <th><FormattedMessage id="periodoPresupuestario.modal.modelo" defaultMessage="Modelo" /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map(function(m) {
                                                        return (
                                                            <tr key={m.id}>
                                                                <td>{m.marca}</td>
                                                                <td>{m.dominio}</td>
                                                                <td>{m.unidad}</td>
                                                                <td>{m.modelo}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            </div>
                                        )
                                    })()}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" onClick={() => this.setState({ showModalMoviles: false })}><FormattedMessage id="Cerrar" defaultMessage="Cerrar" /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default injectIntl(PeriodoPresupuestarioBaseDetalle)
